// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountDetailsStyles from "@flip/App/SharedStyle/MyAccount/Details/MyAccountDetailsStyles";
import { rfqConfirmationDetailsStyles } from "@flip/Overrides/Widgets/RfqConfirmation/RfqConfirmationDetails";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

rfqConfirmationDetailsStyles.jobNameHeadingAndText = {
    ...myAccountDetailsStyles.informationHeadingAndText,
};

rfqConfirmationDetailsStyles.salesRepHeadingAndText = {
    ...myAccountDetailsStyles.informationHeadingAndText,
};

rfqConfirmationDetailsStyles.statusHeadingAndText = {
    ...myAccountDetailsStyles.informationHeadingAndText,
};

rfqConfirmationDetailsStyles.customerHeadingAndText = {
    ...myAccountDetailsStyles.informationHeadingAndText,
};
// XNG-Changes
rfqConfirmationDetailsStyles.customerNumberHeadingAndText = {
    ...myAccountDetailsStyles.informationHeadingAndText,
};

rfqConfirmationDetailsStyles.shipToHeadingAndText = {
    ...myAccountDetailsStyles.informationHeadingAndText,
};

rfqConfirmationDetailsStyles.notesHeadingAndText = {
    ...myAccountDetailsStyles.informationHeadingAndText,
};

rfqConfirmationDetailsStyles.dateLabelText = {
    ...myAccountDetailsStyles.informationHeadingAndText?.heading,
};

rfqConfirmationDetailsStyles.dateGridItem = {
    width: [6, 6, 4, 4, 4],
    css: css`
        flex-direction: column;
        ${TypographyStyle}:not(h3) {
            font-size: 14px;
            line-height: 22px;
        }
    `,
};
